<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M48.5586 14.4053C47.5257 13.2969 46.2993 12.4177 44.9495 11.8178C43.5996 11.2179 42.1529 10.9092 40.6918 10.9092C39.2307 10.9092 37.7839 11.2179 36.4341 11.8178C35.0843 12.4177 33.8579 13.2969 32.825 14.4053L30.6813 16.7045L28.5376 14.4053C26.4512 12.1675 23.6215 10.9103 20.6708 10.9103C17.7202 10.9103 14.8904 12.1675 12.804 14.4053C10.7176 16.6431 9.54547 19.6781 9.54547 22.8428C9.54547 26.0075 10.7176 29.0426 12.804 31.2804L14.9477 33.5795L30.6813 50.4546L46.4149 33.5795L48.5586 31.2804C49.592 30.1725 50.4117 28.8572 50.971 27.4094C51.5303 25.9617 51.8182 24.4099 51.8182 22.8428C51.8182 21.2757 51.5303 19.724 50.971 18.2762C50.4117 16.8285 49.592 15.5131 48.5586 14.4053V14.4053Z" stroke="#43d3b3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M48.5586 14.4053C47.5257 13.2969 46.2993 12.4177 44.9495 11.8178C43.5996 11.2179 42.1529 10.9092 40.6918 10.9092C39.2307 10.9092 37.7839 11.2179 36.4341 11.8178C35.0843 12.4177 33.8579 13.2969 32.825 14.4053L30.6813 16.7045L28.5376 14.4053C26.4512 12.1675 23.6215 10.9103 20.6708 10.9103C17.7202 10.9103 14.8904 12.1675 12.804 14.4053C10.7176 16.6431 9.54547 19.6781 9.54547 22.8428C9.54547 26.0075 10.7176 29.0426 12.804 31.2804L14.9477 33.5795L30.6813 50.4546L46.4149 33.5795L48.5586 31.2804C49.592 30.1725 50.4117 28.8572 50.971 27.4094C51.5303 25.9617 51.8182 24.4099 51.8182 22.8428C51.8182 21.2757 51.5303 19.724 50.971 18.2762C50.4117 16.8285 49.592 15.5131 48.5586 14.4053V14.4053Z" stroke="#43D3B3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M38.1818 28.6364H30.7576L27.5758 36.8182L21.2121 20.4546L18.0303 28.6364H0" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M40.9091 28.6363H33.4849L28.9394 38.1817L22.5758 19.0908L18.0303 28.6363H4.09094" stroke="#43D3B3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="60" height="60" rx="10" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'HeartIcon',
  props: {

  },
  computed: {

  }
};
</script>
<style scoped lang="scss">

</style>
